module.exports = __webpack_public_path__ + "img/mail-gray.abd5ac86.svg";